// @flow
import * as actionTypes from '../constants/action_types'

export type CollaborationSettingsType = {
    boundingBox: boolean,
    framework: boolean,
    locations: boolean,
    analyzeMode: boolean,
    readOnly: boolean,
    realizationsChart: boolean,
}

type CollaborationSettingsActionType = {
    type: string,
    settings: CollaborationSettingsType,
}

// Client should respond to:
const initialState = {
    boundingBox: true,
    framework: false,
    locations: true,
    analyzeMode: true,
    readOnly: false,
}

export default function collaborationSettings(state: CollaborationSettingsType = initialState, action: CollaborationSettingsActionType) {
    let ret = state
    if (action.type === actionTypes.UPDATE_COLLABORATION_SETTINGS) {
        ret = {
            ...state,
            ...action.settings,
        }
    }

    return ret
}
